"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOrRemoveStoreServices = exports.hasFloorplans = void 0;
/**
 * Return if store has floorplans (table layout)
 * @param  {Store} store - Store obj
 * @returns {boolean} true if store has floorplans
 */
const hasFloorplans = (store) => {
    return !!store.floorplans && !!store.floorplans.length;
};
exports.hasFloorplans = hasFloorplans;
/**
 * @param  {CountrSdk} sdk - Countr SDK
 * @param  {Store} store - Store obj
 * @param  {string} service - Service to be checked against
 * @returns Promise of new Store if update with service
 * or return the argument store as service already exist
 */
const addOrRemoveStoreServices = (sdk, store, service, remove = false) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    try {
        const clonedStore = Object.assign({}, store);
        // Check on Login if KDS services exist inside store.extras.services
        const hasKdsService = (_b = (_a = store.extras) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.includes(service);
        if (hasKdsService && remove) {
            clonedStore.extras.services = clonedStore.extras.services.filter((s) => s !== service);
            return yield sdk.stores.update(store._id, clonedStore);
        }
        // If not include it checking if extras.services already exist
        // as Array and if not create a new array with the service name
        if (!hasKdsService) {
            if (((_c = clonedStore.extras) === null || _c === void 0 ? void 0 : _c.services) && Array.isArray(clonedStore.extras.services)) {
                clonedStore.extras.services.push(service);
            }
            else if ((_d = clonedStore.extras) === null || _d === void 0 ? void 0 : _d.services) {
                clonedStore.extras.services = [service];
            }
            else {
                clonedStore.extras = {
                    services: [service]
                };
            }
            return yield sdk.stores.update(store._id, clonedStore);
        }
        return store;
    }
    catch (e) {
        throw new Error(e);
    }
});
exports.addOrRemoveStoreServices = addOrRemoveStoreServices;
